import hdrm from '../../hdrm';

export default () => hdrm.accessors.getSelection();
